export const flowchartRoutes = [
		{
			path: "flowchart/:id",
			name: "Flowchart",
			component: () => import('../pages/flowchart-page.vue'),
		},

	];
